/* eslint-disable max-lines */
/* eslint-disable no-console */
/* eslint-disable max-params */
// 9fbef606107a605d69c0edbcd8029e5d
import layoutAbstractor from '@tcp/core/src/services/abstractors/bootstrap/layout';
import isEmpty from 'lodash/isEmpty';
import { getAPIConfig, isServer, isClient, getSiteIdInCaps } from '@tcp/core/src/utils';
import logger from '@tcp/core/src/utils/loggerInstance';
import handler, { executeExternalAPICall } from '@tcp/core/src/services/handler/handler';
import {
  getIsColorConsolidationEnabled,
  getIsSingleOptionEnabled,
  getIsOrderableFilterEnable,
  isShopThisStoreModeOn,
  getIsSplittingExtendedSizesEnabled,
} from '@tcp/core/src/reduxStore/selectors/session.selectors';
import { getIsBopisFilterOn as getIsBopisFilterOnSlp } from '@tcp/core/src/components/features/browse/SearchDetail/container/SearchDetail.selectors';
import { getIsBopisFilterOn } from '@tcp/core/src/components/features/browse/ProductListing/container/ProductListing.selectors';
import { hashValuesReplace, utilPdpArrayHeader, isCanada } from '../../../utils/utils';
import { executeStatefulAPICall } from '../../handler';
import { extractAttributeValue } from './productParser';
import endpoints from '../../endpoints';
import processHelpers from './processHelpers';
import { getNavTree } from '../../../components/features/browse/ProductDetail/container/ProductDetail.selectors';
import processResponse from './processPdpResponse';
import processHelperUtil from './ProductDetail.util';
import { getFormattedError } from '../../../utils/errorMessage.util';
import { initiatePdpApiCall } from '../../handler/handlerWrapper';

const ORDERABLE_FLAG = 'orderable:true';

const getInventoryDetails = (hasInventory, sizeVariant) => {
  if (!hasInventory) {
    return processHelperUtil.getInventoryStatus(sizeVariant);
  }
  return false;
};

const getMultiPackInfo = (multipackMappings, colorVariant) => {
  return multipackMappings + (multipackMappings !== '' ? ';' : '') + colorVariant.multipack_mapping;
};

const checkIfSingleOptionAvailable = (colorVariant, productAttributes) => {
  if (!colorVariant?.single_mapping) {
    return false;
  }

  const tcpStyleQty = extractAttributeValue(colorVariant, productAttributes.tcpStyleQty);

  return Number(tcpStyleQty) > 1;
};

const getSingleInfo = (singleMapping, colorVariant, productAttributes) => {
  const isSingleOptionAvailable = checkIfSingleOptionAvailable(colorVariant, productAttributes);

  if (isSingleOptionAvailable) {
    return singleMapping + (singleMapping !== '' ? ',' : '') + colorVariant.single_mapping;
  }
  return singleMapping;
};

const getColorReturn = (colorsFitsMap, color, newindex) => {
  let getColor = color;
  if (colorsFitsMap && color in colorsFitsMap) {
    getColor = `${color}-${newindex}`;
  }
  return getColor;
};

const getIsTCPMultipackItem = (colorVariant) => {
  return isCanada()
    ? colorVariant.TCPMultiPackReferenceCanadaStore
    : colorVariant.TCPMultiPackUSStore;
};

const findQuantity = (obj) => {
  let result = 0;
  Object.keys(obj).forEach((key) => {
    if (key.includes('v_Quantity')) {
      result = obj[key];
    }
  });
  return result;
};

const isNewFitAttributeEnabled = (isSplittingExtendedSizesEnabled, attr) => {
  return isSplittingExtendedSizesEnabled && attr;
};

/* eslint-disable max-statements */
export const parseProductFromAPI = (
  product,
  colorIdOrSeoKeyword,
  dontFetchExtraImages,
  breadCrumbs,
  excludeBage,
  isBundleProduct,
  getImgPath,
  state,
  partId,
  oldProductColorId,
  isMultiPack,
  colorConsolidationProduct,
  newFitsEnabled
  // eslint-disable-next-line
) => {
  const baseProduct = processHelperUtil.getBaseProduct(product); // Getting multiple products as color variants
  const productVariants = processHelperUtil.getProductVariants(product);
  const isGiftCard = processHelpers.isGiftCard(baseProduct); // TBD: backend to confirm whether partNumber will always be giftCardBundle for gift cards.
  const productAttributes = processHelpers.getProductAttributes();

  baseProduct.tcpStyleType = extractAttributeValue(product, productAttributes.tcpStyle);
  baseProduct.tcpStyleQty = extractAttributeValue(product, productAttributes.tcpStyleQty);
  let hasFit = false;
  let hasInventory = false;
  let alternateSizes;
  let defaultColorAlternateSizes;
  let otherColorAlternateSizes;

  let hasAdditionalStyles = false;
  let imagesByColor = {};
  // const imagesByColor = extractExtraImages(rawColors, baseProduct.alt_img, getImgPath);

  // This color map is used as an intermediary step to help consolidate all sizes under fits
  const colorsFitsMap = {};
  let multipackMappings = '';
  let singleMapping = '';
  const isSingleOptionEnabled = getIsSingleOptionEnabled(state);
  const isSplittingExtendedSizesEnabled = getIsSplittingExtendedSizesEnabled(state);
  let colorConsolidationMultipackMappings = '';
  const allProductPartNos = [];
  // eslint-disable-next-line
  for (let colorVariant of productVariants) {
    allProductPartNos.push(colorVariant.prodpartno);
    const newindex = colorVariant.imagename;
    if (colorConsolidationProduct && colorVariant.color_consolidated_product) {
      colorConsolidationMultipackMappings = getMultiPackInfo(
        colorConsolidationMultipackMappings,
        colorVariant
      );
    }
    multipackMappings = getMultiPackInfo(multipackMappings, colorVariant);
    if (isSingleOptionEnabled) {
      singleMapping = getSingleInfo(singleMapping, colorVariant, productAttributes);
    }
    let color = processHelperUtil.getProductColorName(isGiftCard, colorVariant);
    const currentColorFitsSizesMap = {};
    let fitName = '';
    const checkForNewFitAttribute = processHelperUtil.checkNewFitAttribute(colorVariant);
    if (isNewFitAttributeEnabled(isSplittingExtendedSizesEnabled, checkForNewFitAttribute)) {
      const fitProductMap = processHelperUtil.getFitProductMap(colorVariant);
      const fit = processHelperUtil.getFitNameFromProductId(fitProductMap, colorVariant?.productid);
      if (fit !== null) {
        fitName = fit;
      }
    }
    if (processHelperUtil.isColorVariant(colorVariant)) {
      // eslint-disable-next-line
      for (let sizeVariant of colorVariant.variants) {
        if (!isNewFitAttributeEnabled(isSplittingExtendedSizesEnabled, checkForNewFitAttribute)) {
          fitName = processHelperUtil.getFitName(sizeVariant);
        }
        if (!currentColorFitsSizesMap[fitName]) {
          currentColorFitsSizesMap[fitName] = [];
        }
        hasInventory = getInventoryDetails(hasInventory, sizeVariant);
        currentColorFitsSizesMap[fitName].push({
          sizeName: processHelperUtil.getSizeName(sizeVariant),
          skuId: sizeVariant.v_item_catentry_id,
          listPrice: processHelperUtil.getListPriceProduct(sizeVariant),
          offerPrice: processHelperUtil.getOfferPriceProduct(sizeVariant),
          maxAvailable: sizeVariant.v_qty,
          maxAvailableBoss: sizeVariant.v_qty_boss,
          maxAvailableInBopisStore: findQuantity(sizeVariant),
          variantId: sizeVariant.variantId,
          variantNo: sizeVariant.v_variant,
          isMultiPack: getIsTCPMultipackItem(colorVariant) && sizeVariant?.isVMPEnabled === 'true',
          prodPartNo: sizeVariant.prodpartno,
          isVMPEnabled: sizeVariant?.isVMPEnabled,
          clothingSize: processHelperUtil.getClothingSize(sizeVariant),
          shoesSize: processHelperUtil.getShoesSize(sizeVariant),
          accessoriesSize: processHelperUtil.getAccessoriesSize(sizeVariant),
        });
      }
    }
    hasFit = !!fitName || hasFit;
    let hasDefaultFit = false;
    const sortOptions = {
      regular: 1,
      slim: 2,
      plus: 3,
      husky: 4,
      other: 5,
    };
    const sortedKeys = processHelperUtil.getSortedKeys(currentColorFitsSizesMap, sortOptions);
    // eslint-disable-next-line
    color = getColorReturn(colorsFitsMap, color, newindex);
    colorsFitsMap[color] = sortedKeys.map((fitNameVal) => {
      const isDefaultFit = fitNameVal.toLowerCase() === 'regular';
      hasDefaultFit = processHelperUtil.getHasDefaultFit(hasDefaultFit, isDefaultFit);

      return {
        fitName: fitNameVal,
        isDefault: isDefaultFit,
        maxAvailable: processHelperUtil.validateQuantityAvailable(
          currentColorFitsSizesMap[fitNameVal]
        ),
        sizes: processHelperUtil.convertMultipleSizeSkusToAlternatives(
          currentColorFitsSizesMap[fitNameVal]
        ),
      };
    });

    if (processHelperUtil.setDefault(hasDefaultFit, colorsFitsMap, color)) {
      colorsFitsMap[color][0].isDefault = true;
    }

    if (processHelperUtil.getDefaultColorAlternateSizes(colorVariant, colorIdOrSeoKeyword)) {
      defaultColorAlternateSizes = colorVariant.additional_styles;
    }
    if (processHelperUtil.getIsAdditionalStyles(hasAdditionalStyles, colorVariant)) {
      otherColorAlternateSizes = colorVariant.additional_styles;
      hasAdditionalStyles = true;
    }
  }

  try {
    alternateSizes = processHelperUtil.getAlternateSizes(
      defaultColorAlternateSizes,
      otherColorAlternateSizes
    );
  } catch (err) {
    alternateSizes = {};
    console.error('API response coming for additional_styles key JSON format is incorrect', err);
  }
  // Generate the colorFitsSizeMap needed for mapping colors to fits/sizes

  const colorObj = processHelperUtil.getColorfitsSizesMap({
    productVariants,
    isGiftCard,
    breadCrumbs,
    getImgPath,
    imagesByColor,
    hasFit,
    isBundleProduct,
    colorsFitsMap,
    excludeBage,
    productAttributes,
    state,
  });
  const { itemColorMap: colorFitsSizesMap, imagesByColor: imagesByColorRes } = colorObj;
  imagesByColor = imagesByColorRes;
  const ratingsAndReviewObj = processHelperUtil.getReviewsCountProduct(
    product,
    colorIdOrSeoKeyword
  );
  const categoryPathMap = processHelperUtil.getCategoryPathMap(baseProduct);
  const categoryPath2Map = processHelperUtil.getCategoryPath2Map(baseProduct);
  const categoryPath = processHelperUtil.getCategory(baseProduct);
  const categoryId = processHelperUtil.getCategoryId(breadCrumbs, baseProduct, categoryPath);
  const category = processHelperUtil.getCategoryValue(baseProduct);
  const updatedProductVariants = productVariants.filter(
    (prod) => !(colorConsolidationProduct && prod.color_consolidated_product)
  );
  const variantsSeoData = processHelperUtil.getSeoDataForProductVariants(
    updatedProductVariants,
    isGiftCard,
    baseProduct
  );
  return processResponse({
    baseProduct,
    categoryPathMap,
    categoryPath2Map,
    colorIdOrSeoKeyword,
    colorFitsSizesMap,
    categoryId,
    isGiftCard,
    isBundleProduct,
    imagesByColor,
    ...ratingsAndReviewObj,
    alternateSizes,
    breadCrumbs,
    category,
    productVariants,
    partId,
    multipackMappings,
    singleMapping,
    oldProductColorId,
    isMultiPack,
    colorConsolidationMultipackMappings,
    allProductPartNos,
    newFitsEnabled,
    variantsSeoData,
  });
};

/**
 * @function moduleResolver
 * @param {object} moduleObjects -  module data to make module graphQL call
 * @summary This will get the modules of the layout from CMS based on categoryId
 */
const moduleResolver = async (moduleObjects, apiConfig) => {
  const response = await layoutAbstractor.getModulesData(moduleObjects, apiConfig);
  return layoutAbstractor.processModuleData(response.data);
};

/**
 * @function formatSlotData
 * @param {array} slotItems -  list of slots
 * @param {string} language -  selected language
 * @summary Formats the slot as per the requirement of graphQL queryBuilder
 */
const formatSlotData = (slotItems, language) => {
  return slotItems.map((slot, index) => {
    return {
      name: slot.moduleName,
      data: {
        contentId: slot.contentId,
        slot: slot.name || `slot_${index + 1}`, // TODO: Remove Temporary Check for slot, as not supported from CMS yet
        lang: language !== 'en' ? language : '', // TODO: Remove Temporary Check for en support, as not supported from CMS yet
      },
    };
  });
};

/**
 * @function layoutResolver
 * @param {object} layoutConfig -  contains categoryId and pageName
 * @summary This will get the layout of the page from CMS based on categoryId
 */
export const layoutResolver = async ({ category, pageName, apiConfig }) => {
  let modules = {};
  const layout = {};
  try {
    const { channelId, siteIdCMS, brandIdCMS, language } = apiConfig;
    const moduleConfig = {
      name: 'promoContent',
      data: {
        brand: brandIdCMS,
        country: siteIdCMS,
        channel: channelId || 'Mobile',
        lang: language === 'en' ? '' : language,
        path: pageName,
        category,
      },
    };
    const result = await handler.fetchModuleDataFromGraphQL({ ...moduleConfig }, apiConfig);
    if (result && result.data && result.data.contentLayout) {
      const {
        data: { contentLayout },
      } = result;
      const moduleObjects = [];
      if (contentLayout) {
        contentLayout.forEach((data) => {
          const dataItems = data.items;
          layout[data.key] = dataItems;
          Object.keys(dataItems).forEach((item) => {
            const slotItems = !!dataItems[item] && dataItems[item].slots;
            if (typeof slotItems === 'object') {
              moduleObjects.push(...slotItems);
            }
          });
        });
        modules = await moduleResolver(formatSlotData(moduleObjects, language), apiConfig);
      }
    }
  } catch (err) {
    logger.error(err);
  }
  return {
    layout,
    modules,
  };
};

const getFieldsValue = (isBotDevice, storeId) => {
  return isServer() && !isBotDevice
    ? `c_accessories,TCPPromotions,tcp_promo_price,tcp_promotion_id,productimage,alt_img,style_partno,swatchimage,giftcard,TCPProductIndUSStore,TCPWebOnlyFlagUSStore,TCPWebOnlyFlagCanadaStore,TCPFitMessageUSSstore,TCPFit,product_name,TCPColor,top_rated,imagename,productid,uniqueId,favoritedcount,TCPBazaarVoiceReviewCount,categoryPath3_catMap,categoryPath2_catMap,product_short_description,style_long_description,min_list_price,min_offer_price,TCPBazaarVoiceRating,product_long_description,seo_token,variantCount,prodpartno,variants,v_tcpfit,v_qty,v_tcpsize,style_name,v_item_catentry_id,v_listprice,v_offerprice,v_qty,variantId,auxdescription,list_of_attributes,additional_styles,TCPLoyaltyPromotionTextUSStore,TCPLoyaltyPLCCPromotionTextUSStore,v_variant,low_offer_price,high_offer_price,low_list_price,high_list_price,long_product_title,TCPOutOfStockFlagUSStore,TCPOutOfStockFlagCanadaStore,v_qty_boss,TCPMultiPackUSStore,TCPMultiPackCanadaStore,TCPMultiPackReferenceUSStore,TCPMultiPackReferenceCanadaStore,single_mapping,multipack_mapping,set_mapping,TCPStyleTypeUS,TCPStyleTypeCA,TCPStyleQTYCA,TCPStyleQTYUS,productfamily,TCPStyleColorCA,TCPStyleColorUS,TCPProductIndCanadaStore,TCPLoyaltyPromoPLCCMultiplierUSStore,TCPLoyaltyPromoMultiplierUSStore,TCPLoyaltyPromoPLCCMultiplierCAStore,TCPLoyaltyPromoMultiplierCAStore,TCPCustomSalePrice,TCPCustomListPrice,v_clothingsize,v_shoessize,v_accessoriessize,isVMPEnabled,is_hard_mark_enable,product_badge,v_Quantity_${storeId},store_specials,early_access_availability`
    : `c_accessories,TCPPromotions,tcp_promo_price,tcp_promotion_id,productimage,alt_img,style_partno,swatchimage,giftcard,TCPProductIndUSStore,TCPWebOnlyFlagUSStore,TCPWebOnlyFlagCanadaStore,TCPFitMessageUSSstore,TCPFit,product_name,TCPColor,top_rated,imagename,productid,uniqueId,favoritedcount,TCPBazaarVoiceReviewCount,categoryPath3_catMap,categoryPath2_catMap,product_short_description,style_long_description,min_list_price,min_offer_price,TCPBazaarVoiceRating,product_long_description,seo_token,variantCount,prodpartno,variants,v_tcpfit,v_qty,v_tcpsize,style_name,v_item_catentry_id,v_listprice,v_offerprice,v_qty,variantId,auxdescription,list_of_attributes,additional_styles,TCPLoyaltyPromotionTextUSStore,TCPLoyaltyPLCCPromotionTextUSStore,v_variant,low_offer_price,high_offer_price,low_list_price,high_list_price,long_product_title,TCPOutOfStockFlagUSStore,TCPOutOfStockFlagCanadaStore,TCPMultiPackUSStore,TCPMultiPackCanadaStore,TCPMultiPackReferenceUSStore,TCPMultiPackReferenceCanadaStore,single_mapping,multipack_mapping,set_mapping,TCPStyleTypeUS,TCPStyleTypeCA,TCPStyleQTYCA,TCPStyleQTYUS,productfamily,TCPStyleColorCA,TCPStyleColorUS,TCPProductIndCanadaStore,TCPLoyaltyPromoPLCCMultiplierUSStore,TCPLoyaltyPromoMultiplierUSStore,TCPLoyaltyPromoPLCCMultiplierCAStore,TCPLoyaltyPromoMultiplierCAStore,TCPCustomSalePrice,TCPCustomListPrice,v_clothingsize,v_shoessize,v_accessoriessize,isVMPEnabled,is_hard_mark_enable,product_badge,influencer_tags,influencer_pick,v_Quantity_${storeId},store_specials,early_access_availability`;
};

const getFilterValue = (productId) => {
  const resValue = `"${productId}"`;
  return `prodpartno:${resValue}`;
};

const isGiftCard = (productId) =>
  productId === 'gift' || (productId || '').toLowerCase() === 'gift card';

const payloadFinder = (
  count,
  productId,
  brand,
  productColorId,
  fields,
  multipackReferencesAPICall,
  alternateBrand
) => {
  const oldPayload = {
    body: {
      variants: true,
      'variants.count': count,
      version: 'V2',
      rows: 20,
      pagetype: 'boolean',
      q: productId,
      promotion: false,
      fields,
      brand: alternateBrand || brand,
    },
    webService: endpoints.getProductInfoById,
    brand,
  };

  const newPayload = {
    body: {
      variants: true,
      'variants.count': count,
      version: 'V2',
      rows: 20,
      pagetype: 'boolean',
      id: productColorId,
      promotion: false,
      fields,
      brand: alternateBrand || brand,
    },
    webService: endpoints.getProductDetails,
    brand,
  };
  return multipackReferencesAPICall ? newPayload : oldPayload;
};
/**
 * @function getProductInfoById
 * @summary This will get product info and all color/sizes for that product
 */

const processApiResponse = (
  products = [],
  productColorId,
  breadCrumb,
  excludeBage,
  isBundleProduct,
  state,
  partId,
  oldProductColorId,
  isMultiPack,
  colorConsolidationProduct,
  newFitsEnabled
) => {
  return parseProductFromAPI(
    products,
    productColorId,
    false,
    breadCrumb,
    excludeBage,
    isBundleProduct,
    processHelperUtil.getImgPath,
    state,
    partId,
    oldProductColorId,
    isMultiPack,
    colorConsolidationProduct,
    newFitsEnabled
  );
};

function generatePayloadForColorConsolidation({ oldPayload, similarStylePartno }) {
  let payload = {};
  let newFields = oldPayload?.body?.fields;
  let newVariants = oldPayload?.body?.variants;
  let colorConsolidatedProductsFetched = true;
  if (isServer()) {
    newFields =
      'imagename,productimage,TCPPrimaryBrandUSStore,TCPPrimaryBrandCanadaStore,TCPPrimaryBrandUSStore,';
    newVariants = false;
    colorConsolidatedProductsFetched = false;
  }
  if (similarStylePartno?.split(',')[0]?.includes('_')) {
    payload = {
      ...oldPayload,
      body: {
        ...oldPayload.body,
        id: similarStylePartno,
        fields: newFields,
        variants: newVariants,
      },
      webService: endpoints.getProductDetails,
      colorConsolidatedProductsFetched,
    };
    delete payload.body.q;
  } else {
    const formattedSimilarStylePartno = similarStylePartno?.split(',')?.join(' ');
    payload = {
      ...oldPayload,
      body: {
        ...oldPayload.body,
        q: formattedSimilarStylePartno,
        fields: newFields,
        variants: newVariants,
      },
      colorConsolidatedProductsFetched,
    };
  }
  return payload;
}

/**
 * @function colorConsolidatioUnbxdApiCall
 * @summary This will get the product info for similar styles that'll come with initial unbxd req and return processed pdp data for all products from both api calls.
 */

const colorConsolidatioUnbxdApiCall = ({
  payload,
  xappURLConfig,
  productColorId,
  breadCrumb,
  excludeBage,
  isBundleProduct,
  state,
  partId,
  oldProductColorId,
  isMultiPack,
  originalURL,
  config,
  similarStylePartno,
  products,
  newFitsEnabled,
}) => {
  const newPayload = generatePayloadForColorConsolidation({
    oldPayload: payload,
    similarStylePartno,
  });
  return initiatePdpApiCall(newPayload, originalURL, xappURLConfig, config)
    .then(
      (resp) => {
        const newProducts =
          resp?.body?.response?.products || resp?.body?.data?.response?.products || [];
        const isColorConsolidatedProductsFetch = newPayload?.colorConsolidatedProductsFetched;
        const colorConsolidatedProduct = newProducts?.map((product) => {
          return { ...product, color_consolidated_product: true, isColorConsolidatedProductsFetch };
        });

        const mergedProducts = [...products, ...colorConsolidatedProduct];
        return processApiResponse(
          mergedProducts,
          productColorId,
          breadCrumb,
          excludeBage,
          isBundleProduct,
          state,
          partId,
          oldProductColorId,
          isMultiPack,
          true,
          newFitsEnabled
        );
      },
      null,
      xappURLConfig
    )
    .catch((err) => {
      // if (err && ((err.status >= 400 && err.status <= 404) || err.status === 500) && isClient()) {
      // TODO - handle it - window.location.href = getErrorPagePath(this.apiHelper._configOptions.siteId);
      // }
      logger.error({
        error: `Error while executing Unbxd API call for color consolidation- ${err}`,
        extraData: {
          componentName: 'productDetail',
          methodName: 'getProductInfoById',
          newPayload,
        },
      });
      throw getFormattedError(err);
      // TODO - handle it - throw this.apiHelper.getFormattedError(err);
    });
};

/**
 * @function sfccInventoryApi
 * @param {array} allProductPartNos - Array of productPartNo
 * @returns {array} data - Array of data for productPartNo provided, consists of information on variant availability.
 * @summary This will get the realtime data from SFCC Inventory. Data contains detail on whether variants of productPartNo is orderable or not.
 */
export function sfccInventoryApi(allProductPartNos, storeId = '', fetchEcomInventory = false) {
  if (allProductPartNos?.length) {
    const STORE_IDS = storeId ? `Store-${storeId.substring(2, 6)}-Inventory` : '';
    const productPartNumberList = allProductPartNos.join(',');
    const BOSS_IDS = `Place_${getSiteIdInCaps()}-BOSS-inventory`;
    const ECOM_ID = `Place_${getSiteIdInCaps()}-inventory`;
    const INVENTORY_IDS = fetchEcomInventory ? `${ECOM_ID}` : `${BOSS_IDS},${STORE_IDS}`;
    const { URI, method, timeout } = endpoints.sfccInventoryApiURL;
    const apiUrl = `${URI}?inventory_ids=${INVENTORY_IDS}&ids=${productPartNumberList}`;
    const payload = {
      webService: {
        URI: apiUrl,
        method,
        timeout,
      },
    };
    return executeStatefulAPICall(payload, null, true)
      .then((res) => {
        if (!res.body) {
          throw new Error('Response body is null');
        }
        return res.body.data;
      })
      .catch((err) => {
        logger.error({
          error: err,
          extraData: {
            title: 'An error occurred executing SFCC Inventory API call',
            componentName: 'productDetail',
            methodName: 'sfccInventoryApi',
            payload,
          },
        });
      });
  }
  return null;
}

/**
 * @function getUniqueSimilarStylePartNos
 * @param {Object} payload - Payload for Unbxd API call.
 * @param {String} similarStylePartno - similarStylePartno string returned in Unbxd API response for 1st product.
 * @returns {String} Unique similar style part numbers.
 * @summary This function will get the unique similarStylePartNos by comparing with the initial payload and removing the partNos that are already present in the payload.
 */
const getUniqueSimilarStylePartNos = ({ payload, similarStylePartno }) => {
  const payloadQuery = payload?.body?.q;
  let partNos = similarStylePartno;
  if (payloadQuery && typeof payloadQuery === 'string') {
    const splittedPartNos = similarStylePartno.split(',');
    const payloadQuerySplitted = payloadQuery.split(' ');
    if (payloadQuerySplitted.length > 1) {
      const updatedPartNos = splittedPartNos.filter(
        (partNo) => !payloadQuerySplitted.includes(partNo.split('_')[0])
      );
      partNos = updatedPartNos.join(',');
    } else {
      const updatedPartNos = splittedPartNos.filter((partNo) => !partNo.includes(payloadQuery));
      partNos = updatedPartNos.join(',');
    }
  }
  return partNos;
};

const shouldExecuteColorConsolidationLogic = ({
  state,
  isBundleProduct,
  payload,
  isColorConsolidationEnabled,
}) => {
  return (
    (getIsColorConsolidationEnabled(state) || isColorConsolidationEnabled) &&
    !isBundleProduct &&
    payload?.body?.q
  );
};

const shouldRetryForOrderable = (supressOrderableRetry, productsData, payload) => {
  return (
    !supressOrderableRetry &&
    productsData.length === 0 &&
    payload?.body?.filter?.includes(ORDERABLE_FLAG)
  );
};

const unbxdApiCall = (
  payload,
  xappURLConfig,
  productColorId,
  breadCrumb,
  excludeBage,
  isBundleProduct,
  state,
  partId,
  oldProductColorId,
  isMultiPack,
  originalURL,
  config,
  isColorConsolidationEnabled,
  supressOrderableRetry,
  newFitsEnabled
) => {
  return initiatePdpApiCall(payload, originalURL, xappURLConfig, config)
    .then(
      // eslint-disable-next-line sonarjs/cognitive-complexity
      (res) => {
        const productsData =
          res?.body?.response?.products || res?.body?.data?.response?.products || [];
        // eslint-disable-next-line sonarjs/no-duplicate-string
        if (shouldRetryForOrderable(supressOrderableRetry, productsData, payload)) {
          const newPayload = { ...payload };
          const filterValue = payload.body.filter;

          newPayload.body.filter = Array.isArray(filterValue)
            ? filterValue.filter((item) => item !== ORDERABLE_FLAG)
            : '';
          return unbxdApiCall(
            newPayload,
            xappURLConfig,
            productColorId,
            breadCrumb,
            excludeBage,
            isBundleProduct,
            state,
            partId,
            oldProductColorId,
            isMultiPack,
            originalURL,
            config,
            isColorConsolidationEnabled,
            undefined,
            newFitsEnabled
          );
        }

        if (
          shouldExecuteColorConsolidationLogic({
            state,
            isBundleProduct,
            payload,
            isColorConsolidationEnabled,
          })
        ) {
          const products =
            res?.body?.response?.products || res?.body?.data?.response?.products || [];
          let allSimilarStylePartnos = '';

          products.forEach((product) => {
            const similarStylePartno = extractAttributeValue(product, 'similarStylePartno');

            if (similarStylePartno) {
              allSimilarStylePartnos += `${similarStylePartno},`;
            }
          });

          // Remove trailing comma
          if (allSimilarStylePartnos.endsWith(',')) {
            allSimilarStylePartnos = allSimilarStylePartnos.slice(0, -1);
          }

          // Remove duplicates
          const uniqueAlllSimilarStylePartNos = [
            ...new Set(allSimilarStylePartnos?.split(',')),
          ].join(',');

          if (allSimilarStylePartnos) {
            const uniqueSimilarStylePartNos = getUniqueSimilarStylePartNos({
              payload,
              similarStylePartno: uniqueAlllSimilarStylePartNos,
            });
            if (uniqueSimilarStylePartNos) {
              return colorConsolidatioUnbxdApiCall({
                payload,
                xappURLConfig,
                productColorId,
                breadCrumb,
                excludeBage,
                isBundleProduct,
                state,
                partId,
                oldProductColorId,
                isMultiPack,
                originalURL,
                config,
                similarStylePartno: uniqueSimilarStylePartNos,
                products,
                newFitsEnabled,
              });
            }
          }
        }

        if (payload?.viewType === 'QV' || payload?.viewType === 'PDP') {
          const response = res?.body?.response;
          const requestUrl = res?.req?.url;
          if (response && response?.products?.length === 0) {
            logger.error(`${payload?.viewType}`, 'Empty Response', {
              requestUrl,
              response,
            });
          }
        }

        return processApiResponse(
          res?.body?.response?.products || res?.body?.data?.response?.products || [],
          productColorId,
          breadCrumb,
          excludeBage,
          isBundleProduct,
          state,
          partId,
          oldProductColorId,
          isMultiPack,
          undefined,
          newFitsEnabled
        );
      },
      null,
      xappURLConfig
    )
    .catch((err) => {
      // if (err && ((err.status >= 400 && err.status <= 404) || err.status === 500) && isClient()) {
      // TODO - handle it - window.location.href = getErrorPagePath(this.apiHelper._configOptions.siteId);
      // }
      console.log(err);
      logger.error({
        error: `Error while executing Unbxd API call - ${err}`,
        extraData: {
          componentName: 'productDetail',
          methodName: 'getProductInfoById',
          payload,
        },
      });
      throw getFormattedError(err);
      // TODO - handle it - throw this.apiHelper.getFormattedError(err);
    });
};

const invokePdpProductsApi = (
  productColorId,
  productPartNumbers,
  breadCrumb,
  excludeBage,
  isBundleProduct,
  state,
  partId,
  oldProductColorId,
  isMultiPack,
  xappURLConfig,
  alternateBrand,
  isViaModuleRecommendation,
  newFitsEnabled
) => {
  const apiConfig = getAPIConfig();
  const productNumber = productPartNumbers;
  if (apiConfig) {
    const pdpEndpoint = endpoints && endpoints.pdpProductApi;
    const fetchReviewURL = hashValuesReplace(
      pdpEndpoint.URI,
      utilPdpArrayHeader(productNumber, {
        brand:
          (!isViaModuleRecommendation && alternateBrand && alternateBrand.toUpperCase()) ||
          (apiConfig && apiConfig.brandId && apiConfig.brandId.toUpperCase()),
        lang: apiConfig && apiConfig.language && apiConfig.language.toUpperCase(),
        site: apiConfig && apiConfig.siteId && apiConfig.siteId.toUpperCase(),
      })
    );

    const formattedPdpApiURL = `${fetchReviewURL}`;

    const payload = {
      webService: {
        URI: formattedPdpApiURL,
        method: pdpEndpoint && pdpEndpoint.method,
      },
      skipApiIdentifier: true,
    };

    return executeStatefulAPICall(payload)
      .then(
        (pdpProductsResponse) => {
          return processApiResponse(
            pdpProductsResponse,
            productColorId,
            breadCrumb,
            excludeBage,
            isBundleProduct,
            state,
            partId,
            oldProductColorId,
            isMultiPack,
            undefined,
            newFitsEnabled
          );
        },
        null,
        xappURLConfig
      )
      .catch((err) => {
        console.log(err);
        logger.error({
          error: `Error while executing PDP products API call - ${err}`,
          extraData: {
            componentName: 'productDetail.js',
            methodName: 'getProductInfoBystyleNumber',
            payload,
          },
        });
        throw getFormattedError(err);
      });
  }
  return null;
};

/* invoke pdp api changes */
// eslint-disable-next-line complexity
const invokePdpApi = (
  productId,
  productColorId,
  breadCrumb,
  excludeBage,
  isBundleProduct,
  state,
  partId,
  oldProductColorId,
  isMultiPack,
  xappURLConfig,
  multipackReferencesAPICall,
  config,
  brand,
  isViaModuleRecommendation,
  newFitsEnabled
) => {
  if (multipackReferencesAPICall === true) {
    return invokePdpProductsApi(
      productId,
      productColorId,
      breadCrumb,
      excludeBage,
      isBundleProduct,
      state,
      partId,
      oldProductColorId,
      isMultiPack,
      xappURLConfig,
      brand,
      isViaModuleRecommendation
    );
  }
  const apiConfig = config || getAPIConfig();
  const styleNumber = productId;
  if (apiConfig) {
    const pdpEndpoint = endpoints && endpoints.pdpApi;
    const fetchReviewURL = hashValuesReplace(
      pdpEndpoint.URI,
      utilPdpArrayHeader(styleNumber, {
        brand:
          (brand && brand.toUpperCase()) ||
          (apiConfig && apiConfig.brandId && apiConfig.brandId.toUpperCase()),
        lang: apiConfig && apiConfig.language && apiConfig.language.toUpperCase(),
        site: apiConfig && apiConfig.siteId && apiConfig.siteId.toUpperCase(),
      })
    );

    const formattedPdpApiURL = `${fetchReviewURL}`;

    const payload = {
      webService: {
        URI: formattedPdpApiURL,
        method: pdpEndpoint.method,
      },
      skipApiIdentifier: true,
    };

    return executeStatefulAPICall(payload)
      .then(
        (pdpResponse) => {
          return processApiResponse(
            pdpResponse,
            productColorId,
            breadCrumb,
            excludeBage,
            isBundleProduct,
            state,
            partId,
            oldProductColorId,
            isMultiPack,
            undefined,
            newFitsEnabled
          );
        },
        null,
        xappURLConfig
      )
      .catch((err) => {
        console.log(err);
        logger.error({
          error: `Error while executing PDP API call - ${err}`,
          extraData: {
            componentName: 'productDetail.js',
            methodName: 'getProductInfoByProdPartNumber',
            payload,
          },
        });
        throw getFormattedError(err);
      });
  }
  return null;
};
/* invoke pdp api changes ends */

const fieldsFinder = (isBundleProduct, isRadialInvEnabled, fields, storeId) => {
  let newFields = fields;
  if (!isBundleProduct) {
    if (isRadialInvEnabled) {
      newFields = newFields.concat(',v_qty_boss');
    }
  } else {
    newFields = `productimage,alt_img,style_partno,swatchimage,related_product_swatch_images,TCPProductIndUSStore,TCPWebOnlyFlagUSStore,TCPWebOnlyFlagCanadaStore,TCPFitMessageUSSstore,product_name,TCPColor,imagename,productid,uniqueId,categoryPath3_catMap,categoryPath2_catMap,product_short_description,style_long_description,min_list_price,min_offer_price,product_long_description,seo_token,prodpartno,auxdescription,list_of_attributes,additional_styles,TCPLoyaltyPromotionTextUSStore,TCPLoyaltyPLCCPromotionTextUSStore,low_offer_price,high_offer_price,low_list_price,high_list_price,long_product_title,TCPOutOfStockFlagUSStore,TCPOutOfStockFlagCanadaStore,product_type,products,TCPMultiPackUSStore,TCPMultiPackReferenceUSStore,TCPMultiPackReferenceCanadaStore,TCPMultiPackCanadaStore,single_mapping,multipack_mapping,set_mapping,TCPStyleTypeUS,TCPStyleTypeCA,TCPStyleQTYCA,TCPStyleQTYUS,productfamily,TCPStyleColorCA,TCPStyleColorUS,TCPProductIndCanadaStore,TCPLoyaltyPromoPLCCMultiplierUSStore,TCPLoyaltyPromoMultiplierUSStore,TCPLoyaltyPromoPLCCMultiplierCAStore,TCPLoyaltyPromoMultiplierCAStore,TCPCustomSalePrice,TCPCustomListPrice,isVMPEnabled,product_badge,is_hard_mark_enable,influencer_tags,influencer_pick,v_Quantity_${storeId},store_specials`;
  }
  return newFields;
};

const pdpApiCondition = (isPdpServiceEnabled, enablePDPServiceABTest) => {
  return (
    (isClient() && isPdpServiceEnabled && enablePDPServiceABTest) ||
    (!isClient() && isPdpServiceEnabled)
  );
};

/* This will send null if multipackReferencesAPICall else will send the original url received */
const formatOriginalURL = (multipackReferencesAPICall, originalURL) => {
  return multipackReferencesAPICall ? null : originalURL;
};

const constructPayload = ({
  count,
  productId,
  brand,
  productColorId,
  fields,
  multipackReferencesAPICall,
  isViaModuleRecommendation,
  alternateBrand,
  isBundleProduct,
  isOrderableFilterEnabled,
  isBopisFlow,
  isFromBarCode,
}) => {
  const payload = payloadFinder(
    count,
    productId,
    brand,
    productColorId,
    fields,
    multipackReferencesAPICall,
    !isViaModuleRecommendation && alternateBrand
  );

  if (isGiftCard(productId)) {
    payload.body.filter = 'giftcard:1';
    payload.body.sort = 'style_sequence asc';
  }
  if (isBundleProduct) {
    payload.body.filter = getFilterValue(productId);
  }
  if (isOrderableFilterEnabled && !isBopisFlow) {
    const { filter } = payload.body;
    const orderableFilter = ORDERABLE_FLAG;
    let filterValue = orderableFilter;

    if (!isEmpty(filter)) {
      filterValue = Array.isArray(filter)
        ? [...filter, orderableFilter]
        : [filter, orderableFilter];
    }

    payload.body.filter = filterValue;
  }
  payload.brand = !isViaModuleRecommendation && alternateBrand;
  if (isFromBarCode) {
    payload.body.filter = '-productType:BUNDLE';
  }
  return payload;
};

export const getStoreSpecificInventory = ({
  productId,
  brand,
  storeId,
  xappURLConfig,
  originalURL,
  apiConfig,
}) => {
  let storeIdTrimmed;
  if (storeId) {
    storeIdTrimmed = storeId?.substring(2);
  }
  const fields = `variantId,v_Quantity_${storeIdTrimmed}`;
  const payload = constructPayload({
    productId,
    brand,
    fields,
    count: 100,
  });
  return initiatePdpApiCall(payload, originalURL, xappURLConfig, apiConfig)
    .then(
      (resp) => {
        return resp.body.response;
      },
      null,
      xappURLConfig
    )
    .catch((err) => {
      // if (err && ((err.status >= 400 && err.status <= 404) || err.status === 500) && isClient()) {
      // TODO - handle it - window.location.href = getErrorPagePath(this.apiHelper._configOptions.siteId);
      // }
      logger.error({
        error: `Error while executing Unbxd API call for color consolidation- ${err}`,
        extraData: {
          componentName: 'productDetail',
          methodName: 'getProductInfoById',
          payload,
        },
      });
      throw getFormattedError(err);
      // TODO - handle it - throw this.apiHelper.getFormattedError(err);
    });
};

const getProductInfoById = (
  xappURLConfig,
  productColorId,
  state,
  brand,
  isBundleProduct,
  isBotDevice,
  originalURL,
  multipackReferencesAPICall,
  partId,
  oldProductColorId,
  isMultiPack,
  isPdpServiceEnabled,
  enablePDPServiceABTest,
  apiConfig,
  otherBrand,
  viaModuleName,
  fromPage = '',
  viewType,
  isColorConsolidationEnabled,
  storeId,
  isUNBXDOrderableFlag,
  supressOrderableRetry,
  isFromBarCode,
  newFitsEnabled
  // eslint-disable-next-line sonarjs/cognitive-complexity
) => {
  const isViaModuleRecommendation = viaModuleName === 'mbox_Recommendation';
  const isAccessoryProduct = fromPage === 'fromPDPAccessories' || fromPage === 'fromQVAccessories';
  // const isRadialInvEnabled = generalStoreView.getIsRadialInventoryEnabled(this.store.getState());
  // const location = routingInfoStoreView.getHistory(this.store.getState()).location;
  // const isBundleProduct = matchPath(location.pathname, { path: PAGES.productBundle.pathPattern });
  const isRadialInvEnabled = true;

  const breadCrumb = processHelperUtil.breadCrumbFactory(state);
  const categoryId =
    breadCrumb[breadCrumb.length - 1] && breadCrumb[breadCrumb.length - 1].categoryId;
  const navigationTree = getNavTree(state);
  const excludeBage = categoryId
    ? processHelperUtil.getNavAttributes(navigationTree, categoryId, 'excludeAttribute')
    : '';
  const alternateProdId =
    productColorId?.indexOf('_') > -1 && !isAccessoryProduct
      ? productColorId?.split('_')[0]
      : productColorId;

  let productId =
    productColorId?.indexOf('-') > -1 && !isAccessoryProduct
      ? productColorId?.split('-')[0]
      : alternateProdId;
  const productsId = productId?.split?.('$')[0];
  if (productId?.length) {
    productId = productsId;
  }
  const isBopisFilterOnPlp = getIsBopisFilterOn(state);
  const isBopisFilterOnSlp = getIsBopisFilterOnSlp(state);
  const isShopThisToreFlow = isShopThisStoreModeOn();
  const isBopisFlow = isShopThisToreFlow || isBopisFilterOnPlp || isBopisFilterOnSlp;

  // eslint-disable-next-line no-param-reassign
  productColorId =
    productColorId?.indexOf('-') > -1 && !isAccessoryProduct
      ? productColorId?.replace('-', '_')
      : productColorId; // As ProductColorId response has always _ rather than hyphen(-)
  let fields = getFieldsValue(isBotDevice, storeId);
  let count = 100;
  fields = fieldsFinder(isBundleProduct, isRadialInvEnabled, fields, storeId);
  if (
    fields ===
    `productimage,alt_img,style_partno,swatchimage,related_product_swatch_images,TCPProductIndUSStore,TCPWebOnlyFlagUSStore,TCPWebOnlyFlagCanadaStore,TCPFitMessageUSSstore,product_name,TCPColor,imagename,productid,uniqueId,categoryPath3_catMap,categoryPath2_catMap,product_short_description,style_long_description,min_list_price,min_offer_price,product_long_description,seo_token,prodpartno,auxdescription,list_of_attributes,additional_styles,TCPLoyaltyPromotionTextUSStore,TCPLoyaltyPLCCPromotionTextUSStore,low_offer_price,high_offer_price,low_list_price,high_list_price,long_product_title,TCPOutOfStockFlagUSStore,TCPOutOfStockFlagCanadaStore,product_type,products,TCPMultiPackUSStore,TCPMultiPackReferenceUSStore,TCPMultiPackReferenceCanadaStore,TCPMultiPackCanadaStore,single_mapping,multipack_mapping,set_mapping,TCPStyleTypeUS,TCPStyleTypeCA,TCPStyleQTYCA,TCPStyleQTYUS,productfamily,TCPStyleColorCA,TCPStyleColorUS,TCPProductIndCanadaStore,TCPLoyaltyPromoPLCCMultiplierUSStore,TCPLoyaltyPromoMultiplierUSStore,TCPLoyaltyPromoPLCCMultiplierCAStore,TCPLoyaltyPromoMultiplierCAStore,TCPCustomSalePrice,TCPCustomListPrice,isVMPEnabled,product_badge,is_hard_mark_enable,v_Quantity_${storeId},store_specials,early_access_availability`
  ) {
    count = 0;
  }
  const alternateBrand = otherBrand;
  // Both condition are refering to same siteConfigkey IS_UNBXD_ORDERABLE_FLAG. This is used because to get on SSR also.
  const isOrderableFilterEnabled = getIsOrderableFilterEnable(state) || isUNBXDOrderableFlag;
  const payload = constructPayload({
    count,
    productId,
    brand,
    productColorId,
    fields,
    multipackReferencesAPICall,
    isViaModuleRecommendation,
    alternateBrand,
    isBundleProduct,
    isOrderableFilterEnabled,
    isBopisFlow,
    isFromBarCode,
  });

  if (pdpApiCondition(isPdpServiceEnabled, enablePDPServiceABTest)) {
    return invokePdpApi(
      productId,
      productColorId,
      breadCrumb,
      excludeBage,
      isBundleProduct,
      state,
      partId,
      oldProductColorId,
      isMultiPack,
      xappURLConfig,
      multipackReferencesAPICall,
      apiConfig,
      alternateBrand,
      isViaModuleRecommendation,
      newFitsEnabled
    );
  }
  const originalURLToSend = formatOriginalURL(multipackReferencesAPICall, originalURL);
  payload.brand = !isViaModuleRecommendation && alternateBrand;
  payload.viewType = viewType;
  return unbxdApiCall(
    payload,
    xappURLConfig,
    productColorId,
    breadCrumb,
    excludeBage,
    isBundleProduct,
    state,
    partId,
    oldProductColorId,
    isMultiPack,
    originalURLToSend,
    apiConfig,
    isColorConsolidationEnabled,
    supressOrderableRetry,
    newFitsEnabled
  );
};

const getReviewContent = (reviewStats, productId) => {
  const stats = {
    avgRating: 0,
    totalReviewCount: 0,
  };
  try {
    const rating = reviewStats.Includes.Products[productId].ReviewStatistics;
    stats.avgRating = rating.AverageOverallRating;
    stats.totalReviewCount = rating.TotalReviewCount;
    return stats;
  } catch {
    return stats;
  }
};

/**
 * @function getProductBVRatings
 * @param {object} productId -  productId of product to fetch its review
 * @summary This will get the review stats from bazar voice
 */
export const getProductBVReviewStats = async (productId) => {
  const apiConfig = getAPIConfig();
  if (apiConfig && apiConfig.BV_API_URL) {
    const serviceConfig = endpoints.getBazaarVoiceRatings;
    const utilArrayHeader = ({ pId, passKey, limit }) => {
      return [
        {
          key: '#product-id#',
          value: pId,
        },
        {
          key: '#pass-key#',
          value: passKey,
        },
        {
          key: '#limit#',
          value: limit,
        },
      ];
    };
    const fetchReviewURL = hashValuesReplace(
      serviceConfig.URI,
      utilArrayHeader({
        pId: productId,
        passKey: apiConfig.BV_API_KEY,
        limit: 1,
      })
    );

    const formattedBvApiURL = `${apiConfig.BV_API_URL}/${fetchReviewURL}`;

    const payload = {
      webService: {
        URI: formattedBvApiURL,
        method: serviceConfig.method,
        timeout: serviceConfig.timeout,
      },
    };

    return executeExternalAPICall(payload)
      .then((res) => {
        return getReviewContent(res.body, productId);
      })
      .catch((err) => {
        console.log(err);
      });
  }
  return null;
};

/**
 * @function getSimilarProductInfo
 * @param {Array} productIds - Array of product IDs to fetch similar products.
 * @param {Array} fields - Array of fields to retrieve for each product.
 * @param {Object} config - Configuration object for the API call.
 * @returns {Promise} - Promise resolving to the API response.
 * @summary Fetches similar products using Unbxd API.
 */
export const getSimilarProductInfo = ({
  productIds,
  fields,
  brand,
  alternateBrand,
  xappURLConfig,
  originalURL,
  apiConfig,
  isUNBXDOrderableFlag,
  state,
}) => {
  const productIdsString = productIds;
  const payload = payloadFinder(0, '', brand, productIdsString, fields, true, alternateBrand);
  payload.body.id = productIdsString;

  // Both condition are refering to same siteConfigkey IS_UNBXD_ORDERABLE_FLAG. This is used because to get on SSR also.
  const isOrderableFilterEnabled = getIsOrderableFilterEnable(state) || isUNBXDOrderableFlag;
  const baseFilter = 'v_qty:[1 TO *] OR isVMPEnabled:true';

  if (isOrderableFilterEnabled) {
    payload.body.filter = `(orderable:true) AND (${baseFilter})`;
  } else {
    payload.body.filter = baseFilter;
  }

  return initiatePdpApiCall(payload, originalURL, xappURLConfig, apiConfig)
    .then((resp) => {
      return resp?.body?.response?.products || resp?.body?.data?.response?.products || [];
    })
    .catch((err) => {
      logger.error({
        error: `Error while fetching similar products - ${err}`,
        extraData: {
          componentName: 'productDetail',
          methodName: 'getSimilarProductInfo',
          payload,
        },
      });
      throw getFormattedError(err);
    });
};

export default getProductInfoById;
